// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".page-notification-page-notification-3bj2FQkkmwr{-webkit-box-align:start;align-items:flex-start}.page-notification-error-1Mvwwkvjmwr{background-color:var(--error-bg)}.page-notification-warning-2bWPVCPumwr{background-color:var(--warning-bg)}.page-notification-info-4jarlexqmwr{background-color:var(--info-bg)}.page-notification-infowhite-7J0QxRebmwr{background-color:white}.page-notification-success-1UUDz3e6mwr{background-color:rgba(207,239,167,0.4)}.page-notification-content-5ZTJ7BGQmwr{-webkit-box-align:start;align-items:flex-start;-webkit-box-flex:0;flex:0 1 100%}.page-notification-buttonContainer-2fZvQ13zmwr{-webkit-box-flex:0;flex:0 0 auto;margin:-4px -4px -4px 16px}.page-notification-text-5JzGtHg5mwr{margin-left:8px;color:var(--primary-text);font-size:14px;line-height:20px}.page-notification-full-width-text-3DrjsCLlmwr{-webkit-box-flex:1;flex-grow:1}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"page-notification": "page-notification-page-notification-3bj2FQkkmwr " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"pageNotification": "page-notification-page-notification-3bj2FQkkmwr " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"error": "page-notification-error-1Mvwwkvjmwr page-notification-page-notification-3bj2FQkkmwr " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"warning": "page-notification-warning-2bWPVCPumwr page-notification-page-notification-3bj2FQkkmwr " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"info": "page-notification-info-4jarlexqmwr page-notification-page-notification-3bj2FQkkmwr " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"infowhite": "page-notification-infowhite-7J0QxRebmwr page-notification-page-notification-3bj2FQkkmwr " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"success": "page-notification-success-1UUDz3e6mwr page-notification-page-notification-3bj2FQkkmwr " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"content": "page-notification-content-5ZTJ7BGQmwr " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"buttonContainer": "page-notification-buttonContainer-2fZvQ13zmwr",
	"text": "page-notification-text-5JzGtHg5mwr",
	"full-width-text": "page-notification-full-width-text-3DrjsCLlmwr",
	"fullWidthText": "page-notification-full-width-text-3DrjsCLlmwr"
};
module.exports = exports;
